<template>
    <v-main>
        <v-container fluid :class="{'smallfont': $vuetify.breakpoint.lgAndDown}">
            <v-card flat class="px-2 mt-1">
                <div style="display: flex; align-items: center; gap: 20px; margin-right: 40px;">
                    <v-row>
                        <v-col cols="6" class="px-4">
                            <v-text-field v-model="search" label="Search in results" single-line hide-details prepend-icon="mdi-magnify"></v-text-field>
                        </v-col>
                        <v-col cols="2" class="px-4">
                            <v-checkbox v-model="includeDenied" label="Include denied" denses></v-checkbox>
                        </v-col>
                        <v-col cols="4" class="px-4">
                            <v-text-field v-model="remark" label="Book/deny remark" single-line hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </div>
                <v-data-table 
                    :items="filteredItems" 
                    :headers="headers" 

                    :search="search"

                    no-data-text="No bookings to display"
                    loading-text="Loading data...please wait" 
                    :custom-filter="customSearch"
                    :loading="loading">
                    <template v-slot:item="props">
                        <tr>
                            <td @click="$router.open('/heho/onHeho/' + props.item.heho_encrid + '/' + props.item.huis_encrid)" class="font-row"><a>{{ props.item.heho_code }} </a></td>
                            <td class="font-row"><v-chip small :color=props.item.hust_kleur><span class="chiptext">{{ props.item.hust_code }}</span></v-chip></td>
                            <td class="font-row">{{ props.item.heho_type }}</td>
                            <td style="display: flex; gap: 4px; flex-direction: row; align-items: center; justify-content: center;">
                                <!-- <v-icon :color="props.item.heho_overrule?'error':'transparent'">mdi-registered-trademark</v-icon> -->
                                <v-icon :color="props.item.heho_expert_notified?`${props.item.heho_expert_notification_color}`:'transparent'">mdi-bell-check</v-icon>
                            </td>
                            <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)" class="font-row"><a> {{ props.item.huis_code }} </a></td>
                            <td class="font-row">{{ props.item.heho_contract }}</td>
                            <td class="font-row">{{ props.item.expert_naam }}</td>
                            <td class="font-row">{{ $moment(props.item.heho_dt).format("DD-MMM-YYYY HH:mm") }}</td>
                            <td class="font-row">{{ props.item.heho_pers }}</td>
                            <!-- <td class="font-row">{{ $moment(props.item.heho_van_dat).format("DD-MMM-YYYY ddd") }}</td>
                            <td class="font-row">{{ $moment(props.item.heho_tm_dat).format("DD-MMM-YYYY ddd") }}</td> -->
                            <td class="font-row">{{ props.item.heho_van_dat }}</td>
                            <td class="font-row">{{ props.item.heho_tm_dat }}</td>
                            <td class="font-row">
                                <btn_component type="avatar_icon" color="green" tooltip="Approve" icon="mdi-check-circle-outline" size="small" :data="props.item.heho_encrid" @actionClick="approveHeho"/>
                                <btn_component type="avatar_icon" color="red"   tooltip="Decline" icon="mdi-close-circle-outline" size="small" :data="props.item.heho_encrid" @actionClick="declineHeho"/>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <!-- <div v-if="!loading&&items.length>0" style="display: flex; align-items: center; justify-content :end; margin-top: 10px; font-size: small; color:grey;">
                    <v-btn icon @click="goToFirstPage" :disabled="page === 1"><v-icon>mdi-chevron-double-left</v-icon></v-btn>
                    <v-btn icon @click="goToPreviousPage" :disabled="page === 1"><v-icon>mdi-chevron-left</v-icon></v-btn>
                    <div style="display: flex; justify-content: center; align-items: center; margin-left: 15px; margin-right: 15px; min-width: 80px;">Page {{ page }} of {{ lastPage }}</div>
                        <v-btn icon @click="goToNextPage" :disabled="page === lastPage"><v-icon>mdi-chevron-right</v-icon></v-btn>
                        <v-btn icon @click="goToLastPage" :disabled="page === lastPage"><v-icon>mdi-chevron-double-right</v-icon></v-btn>
                    <div style="margin-left: 15px; min-width: 150px;">Record {{ startRecord }}-{{ eindRecord }} of {{ filteredItems.length }} </div>
                </div> -->
            </v-card>
        </v-container>
        <navBar title="Ares - Main menu" :home="true" :accolist="false" type="main" />
        <standard_dialog ref="standard_dialog" />
        <!-- <standard_dialog ref="standard_dialog" @standard_dialog_close="goToFirstPage" /> -->
    </v-main>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    import standard_dialog from '@/components/ui/standard_dialog.vue';

    export default {
        components: {
            navBar,
            btn_component,
            standard_dialog,
        },
        data() {
            return {
                loading: true,
                includeDenied: false,
                search: "",
                remark: "",
                items: [],
                headers: [
                    { text: 'Id', value: 'heho_code' },
                    { text: 'Status', value: 'hust_code' },
                    { text: 'Type', value: 'heho_type' },
                    { text: 'Notifications', sortable: false, align: 'center' },
                    { text: 'Accommodation', value: 'huis_code' },
                    { text: 'Contract type', value: 'heho_contract' },
                    { text: 'Rental expert', value: 'expert_naam' },
                    { text: 'Booking date', value: 'heho_dt' },
                    { text: 'Persons', value: 'heho_pers' },
                    { text: 'Arrival date', value: 'heho_van_dat' },
                    { text: 'Departure date', value: 'heho_tm_dat' },
                    { text: '', sortable: false, width: '7%' }
                ]
            }
        },
        computed: {
            filteredItems() {
                return this.items.filter(item => {
                    return this.includeDenied || (item.hust_code !== "A-DNY");
                });
            },
        },
        mounted() {
            this.searchHostRequest();
        },
        methods: {
            searchHostRequest() {
                this.loading=true;
                this.items = [];
                this.$axios.post("ares/json/ares/heho/searchHostRequests.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchHostRequests"
                    },
                    searchHostRequests: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$refs.standard_dialog.setWidth(450);
                        this.$refs.standard_dialog.setTextClass("text-center text-body-1 pa-3 pt-6");
                        this.$refs.standard_dialog.open('warning', 'Warning', res.data.error.message);
                        this.showClearButton = true
                        this.loading = false;
                    } else {
                        this.items = res.data.searchHostRequests;
                        console.log(this.items)
                        this.loading = false;                   
                    }
                });
            },
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            approveHeho(heho_encrid) {
                this.updHehoBknDny("bkn", heho_encrid)
            },
            declineHeho(heho_encrid) {
                this.updHehoBknDny("dny", heho_encrid)
            },
            updHehoBknDny(bknDny, heho_encrid) {
                this.$axios.post("ares/json/ares/heho/updHehoBknDny.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHehoBknDny",
                    },
                    updHehoBknDny: {
                        heho_encrid: heho_encrid,
                        heho_bkn_dny: bknDny,
                        heho_result: this.remark,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.updHehoBknDny.text,
                            color: res.data.updHehoBknDny.color,
                        });
                        if (res.data.updHehoBknDny.color == "success" || res.data.updHehoBknDny.color == "warning" ) {
                            this.searchHostRequest();
                            this.remark = "";
                        }
                    }
                });
            },
        }
    };
</script> 

<style scoped>
    .grid-item-error {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid red;
        color: red;
        cursor: default;
    }

    .grid-item-warning {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid orange;
        color: orange;
        cursor: default;
    }

    .grid-item-pending {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid blue;
        color: blue;
        cursor: default;
    }

    .grid-item-change {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid #FF8800;
        color: #FF8800;
        cursor: default;
    }

    .grid-item-ok {
        background: transparent !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        border: 2px solid green;
        color: green;
        cursor: default;
    }

    .format-amount {
        text-align: end;
    }
    .font-row{
        font-size: smaller !important;
    }
    .flex{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .last-item {
        margin-left: auto;
    }
    .chiptext {
       color: black !important;
    }
</style>
